// extracted by mini-css-extract-plugin
export default {"button":"shareProfileBtn_button__JzSTF","icon":"shareProfileBtn_icon__gjkQs"};